module.exports = __webpack_public_path__ + "static/media/los-angeles.73d8ec96.jpg";